import React, { useState, useEffect } from "react";
import { message, Upload, Button,Divider ,InputNumber,Input,Checkbox,Select,notification,Col, Row} from "antd";
import { InboxOutlined,SaveOutlined,ArrowRightOutlined,ArrowLeftOutlined} from "@ant-design/icons";
import "./History.scss";
import * as XLSX from 'xlsx';
import {post} from "../../../api/post";
import TableFullEditable from "../../../components/table/tableFullEditable/TableFullEditable";


export default function History() {
  const { Option } = Select;
  const { Dragger } = Upload;

  const [page, setPage] = useState(0);
  const [circular, setCircular] = useState(false);
  const [jsonData, setJsonData] = useState([]);
  const [select, setselect] = useState([]);
  const [columns, setcolumns] = useState([]);
  const [dataManag, setdataManag] = useState([]);
  const [dataTable, setdataTable] = useState([]);
  const [checkbox, setcheckbox] = useState([]);
  
  const [order_mode, setorder_mode] = useState(['pickup','delivery','shipment']);
  const [order_idhubN, setorder_idhubN] = useState(1)
  const [order_idhubVec, setorder_idhubVec] = useState([''])
  const [order_idhub, setorder_idhub] = useState(
    [<Col><Input key={0} onChange={(input)=>idHubChange(input,0)} addonBefore="Hub name" addonAfter="0" placeholder="Hub 0" /><p></p></Col>]
  );
  const [order_earlytime1, setorder_earlytime1] = useState('hh:mm');
  const [order_latetime1, setorder_latetime1] = useState('hh:mm');
  const [order_servicetime1, setorder_servicetime1] = useState(1.0);
  const [order_weight, setorder_weight] = useState(1.0);
  const [order_earlytime2, setorder_earlytime2] = useState('hh:mm');
  const [order_latetime2, setorder_latetime2] = useState('hh:mm');
  const [order_servicetime2, setorder_servicetime2] = useState(1.0);
  const [order_bolactivo, setorder_bolactivo] = useState(['0','1']);

  useEffect(() => {
    var vector=[]
    var checkboxAux={}
    if(page===2){
      var conjunto = new Set(['order_mode','order_idhub','order_earlytime1','order_latetime1','order_servicetime1','order_weight','order_earlytime2','order_latetime2','order_servicetime2','order_bolactivo']);
      for (var i = 0; i < select.length; i++) {
        if (conjunto.has(select[i])) {
          vector=[...vector,select[i]]
        }
      }
    }
    if(vector.includes('order_mode')){checkboxAux.order_mode=false}
    if(vector.includes('order_idhub')){checkboxAux.order_idhub=false}
    if(vector.includes('order_earlytime1')){checkboxAux.order_earlytime1=false}
    if(vector.includes('order_latetime1')){checkboxAux.order_latetime1=false}
    if(vector.includes('order_servicetime1')){checkboxAux.order_servicetime1=false}
    if(vector.includes('order_weight')){checkboxAux.order_weight=false}
    if(vector.includes('order_earlytime2')){checkboxAux.order_earlytime2=false}
    if(vector.includes('order_latetime2')){checkboxAux.order_latetime2=false}
    if(vector.includes('order_servicetime2')){checkboxAux.order_servicetime2=false}
    if(vector.includes('order_bolactivo')){checkboxAux.order_bolactivo=false}
    // console.log('cucu',checkbox)
    // console.log('cucu',vector)
    setdataManag(vector)
    setcheckbox((prev)=>{
      const aux = [...prev];
      return aux}
    )
  },[page, setPage])

  useEffect(() => {
    var columns_aux=[]
    var selected_aux=[]
    if(jsonData.length>0){
      for (let i = 0; i < jsonData[0].length; i=i+3) {
        selected_aux=new Array(jsonData[0].length)
        columns_aux.push(
          <Row style= {{justifyContent:(jsonData[0][i+2]!==undefined)?'space-between':'start'}}>
            <Col>
              <h2 style={{ fontFamily:'report-bold',fontSize:'15px',}}>{jsonData[0][i]}</h2>
              <Select
                        placeholder="Match the column"
                        onChange={(e) => {
                          var aux=String(e)
                          var number =parseInt(aux.split('-')[1])
                          // console.log(number) 
                          // console.log(select)
                          setselect((prev)=>{ 
                            var selectPost=prev
                            selectPost[number]=aux.split('-')[0]
                            return selectPost})
                        }}
                        style={{
                          width: '300px',
                        }}
                        defaultValue={select[i]}
                      >
                        <Option value={`None-${i}`}>None</Option>
                        <Option value={`order_id-${i}`}>Row ID (0, 1, 2...)</Option>
                        <Option value={`order_name-${i}`}>Order name ("Order 1")</Option>
                        <Option value={`order_mode-${i}`}>Order mode ('delivery','pickup'...)</Option>
                        <Option value={`order_idhub-${i}`}>Hub departure (0, 1, 2...)</Option>
                        <Option value={`order_lat1-${i}`}>Latitude</Option>
                        <Option value={`order_lon1-${i}`}>Longitude</Option>
                        <Option value={`order_earlytime1-${i}`}>Minimum delivery time (00:00)</Option>
                        <Option value={`order_latetime1-${i}`}>Maximum delivery time (00:00)</Option>
                        <Option value={`order_servicetime1-${i}`}>Service time (0, 1, 2...)</Option>
                        <Option value={`order_items-${i}`}>Order number (0, 1, 2...)</Option>
                        <Option value={`order_weight-${i}`}>Weight (1, 1.5, 2...)</Option>
                        <Option value={`order_pc-${i}`}>Postal code</Option>
                        <Option value={`order_lat2-${i}`}>Latitude (shipment)</Option>
                        <Option value={`order_lon2-${i}`}>Longitude (shipment)</Option>
                        <Option value={`order_earlytime2-${i}`}>Minimum delivery time (shipment)</Option>
                        <Option value={`order_latetime2-${i}`}>Maximum delivery time (shipment)</Option>
                        <Option value={`order_servicetime2-${i}`}>Service time (shipment)</Option>
                        <Option value={`order_bolactivo-${i}`}>Order to place (0 - 1)</Option>
                        <Option value={`order_revenue-${i}`}>Billing</Option>
                      </Select>
              <p></p>
            </Col> 
            {(jsonData[0][i+1]!==undefined)?<Col>
              <h2 style={{ fontFamily:'report-bold',fontSize:'15px',}}>{jsonData[0][i+1]}</h2>
              <Select
                        placeholder="Match the column"
                        onChange={(e) => {
                          var aux=String(e)
                          var number =parseInt(aux.split('-')[1])
                          // console.log(number)
                          // console.log(select)
                          setselect((prev)=>{
                            var selectPost=prev
                            selectPost[number]=aux.split('-')[0]
                            return selectPost}) 
                        }}
                        style={{
                          width: '300px',
                        }}
                        defaultValue={select[i+1]}
                      >
                        <Option value={`None-${i+1}`}>None</Option>
                        <Option value={`order_id-${i+1}`}>Row ID (0, 1, 2...)</Option>
                        <Option value={`order_name-${i+1}`}>Order name ("Order 1")</Option>
                        <Option value={`order_mode-${i+1}`}>Order mode ('delivery','pickup'...)</Option>
                        <Option value={`order_idhub-${i+1}`}>Hub departure (0, 1, 2...)</Option>
                        <Option value={`order_lat1-${i+1}`}>Latitude</Option>
                        <Option value={`order_lon1-${i+1}`}>Longitude</Option>
                        <Option value={`order_earlytime1-${i+1}`}>Minimum delivery time (00:00)</Option>
                        <Option value={`order_latetime1-${i+1}`}>Maximum delivery time (00:00)</Option>
                        <Option value={`order_servicetime1-${i+1}`}>Service time (0, 1, 2...)</Option>
                        <Option value={`order_items-${i+1}`}>Order number (0, 1, 2...)</Option>
                        <Option value={`order_weight-${i+1}`}>Weight (1, 1.5, 2...)</Option>
                        <Option value={`order_pc-${i+1}`}>Postal code</Option>
                        <Option value={`order_lat2-${i+1}`}>Latitude (shipment)</Option>
                        <Option value={`order_lon2-${i+1}`}>Longitude (shipment)</Option>
                        <Option value={`order_earlytime2-${i+1}`}>Minimum delivery time (shipment)</Option>
                        <Option value={`order_latetime2-${i+1}`}>Maximum delivery time (shipment)</Option>
                        <Option value={`order_servicetime2-${i+1}`}>Service time (shipment)</Option>
                        <Option value={`order_bolactivo-${i+1}`}>Order to place (0 - 1)</Option>
                        <Option value={`order_revenue-${i+1}`}>Billing</Option>
                      </Select>
              <p></p>
            </Col>:<Col></Col>}
            {(jsonData[0][i+2]!==undefined)?<Col>
              <h2 style={{ fontFamily:'report-bold',fontSize:'15px',}}>{jsonData[0][i+2]}</h2>
              <Select
                        placeholder="Match the column"
                        onChange={(e) => {
                          var aux=String(e)
                          var number =parseInt(aux.split('-')[1])
                          // console.log(number)
                          // console.log(select)
                          setselect((prev)=>{
                            var selectPost=prev
                            selectPost[number]=aux.split('-')[0]
                            return selectPost})
                        }}
                        style={{
                          width: '300px',
                        }}
                        defaultValue={select[i+2]}
                      >
                        <Option value={`None-${i+2}`}>None</Option>
                        <Option value={`order_id-${i+2}`}>Row ID (0, 1, 2...)</Option>
                        <Option value={`order_name-${i+2}`}>Order name ("Order 1")</Option>
                        <Option value={`order_mode-${i+2}`}>Order mode ('delivery','pickup'...)</Option>
                        <Option value={`order_idhub-${i+2}`}>Hub departure (0, 1, 2...)</Option>
                        <Option value={`order_lat1-${i+2}`}>Latitude</Option>
                        <Option value={`order_lon1-${i+2}`}>Longitude</Option>
                        <Option value={`order_earlytime1-${i+2}`}>Minimum delivery time (00:00)</Option>
                        <Option value={`order_latetime1-${i+2}`}>Maximum delivery time (00:00)</Option>
                        <Option value={`order_servicetime1-${i+2}`}>Service time (0, 1, 2...)</Option>
                        <Option value={`order_items-${i+2}`}>Order number (0, 1, 2...)</Option>
                        <Option value={`order_weight-${i+2}`}>Weight (1, 1.5, 2...)</Option>
                        <Option value={`order_pc-${i+2}`}>Postal code</Option>
                        <Option value={`order_lat2-${i+2}`}>Latitude (shipment)</Option>
                        <Option value={`order_lon2-${i+2}`}>Longitude (shipment)</Option>
                        <Option value={`order_earlytime2-${i+2}`}>Minimum delivery time (shipment)</Option>
                        <Option value={`order_latetime2-${i+2}`}>Maximum delivery time (shipment)</Option>
                        <Option value={`order_servicetime2-${i+2}`}>Service time (shipment)</Option>
                        <Option value={`order_bolactivo-${i+2}`}>Order to place (0 - 1)</Option>
                        <Option value={`order_revenue-${i+2}`}>Billing</Option>
                      </Select>
              <p></p>
            </Col>:<Col></Col>}
          </Row>
          
        )
      }
      setcolumns((prevColumns)=>{
        // console.log('cucu',columns_aux, ' y ',prevColumns)
        return columns_aux;
      })
      setselect((prev)=>{return selected_aux})
    }
  }, [jsonData,setJsonData]); 
 
  function onChange(nombre,e){
    // console.log(`checked`, checkbox);
    setcheckbox((prev)=>{
      var check=prev
      check[nombre]=e.target.checked
      return check
    })
    // console.log(`checked`, checkbox);
  };

  async function processData(){
    if(dataManag.length>0){
      const keys = Object.keys(checkbox);
      keys.forEach(key => {
        console.log('Ahí va',key,checkbox[key]);
        if(checkbox[key]){
          switch (key) {
            case 'order_mode':
              // console.log('Opción: ',key,dataTable,select);
              setdataTable((prev)=>{
                  const aux = [...prev];
                  for (var i = 0; i < aux.length; i++) {
                    if(aux[i].order_mode===order_mode[0]){
                      aux[i].order_mode='pickup'
                    }else if(aux[i].order_mode===order_mode[1]){
                      aux[i].order_mode='delivery'
                    }else if(aux[i].order_mode===order_mode[2]){
                      aux[i].order_mode='shipment'
                    }
                  }
                  return aux
                }
              )
              break;
            case 'order_idhub':
              // console.log('Opción: ',key,dataTable,select,order_idhubN,order_idhub,order_idhubVec);
              setdataTable((prev)=>{
                const aux = [...prev];
                for (var i = 0; i < aux.length; i++) {
                  for (var j = 0; j < order_idhubVec.length; j++) {
                    // console.log('searching 5: ',order_idhub[j].props.children[0].props);
                    // console.log('=======================================================');
                    // console.log('searching 6: ',order_idhub[j].props.children[0].props.placeholder);
                    if(String(aux[i].order_idhub)===order_idhubVec[j]){
                      aux[i].order_idhub=parseInt(order_idhub[j].props.children[0].props.addonAfter)
                    }
                  }
                }
                return aux
              })
              break;
            case 'order_latetime1':
            case 'order_earlytime2':
            case 'order_latetime2':
            case 'order_earlytime1':
              // console.log('Opción: ',key,dataTable,select);
              setdataTable((prev)=>{
                const aux = [...prev];
                const auxi = (key==='order_earlytime1')
                  ?order_earlytime1
                  :(key==='order_latetime1')
                    ?order_latetime1
                    :(key==='order_earlytime2')
                      ?order_earlytime2
                      :(key==='order_latetime2')
                        ?order_latetime2
                        :order_latetime2
                for (var i = 0; i < aux.length; i++) {
                  switch (auxi) {
                    case 'UnixMili':
                    case 'UnixMicro':
                    case 'Unix':
                      var auxiliar = parseInt(String(aux[i][key]))
                      const date = (auxi==='Unix')
                        ?new Date(auxiliar * 1000)
                        :(auxi==='UnixMili')
                          ?new Date(auxiliar)
                          :new Date(parseInt(auxiliar/1000))
                      console.log(date,auxiliar,auxi,key,aux)
                      const hours = date.getHours();
                      const minutes = date.getMinutes();
                      const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
                      aux[i][key]=formattedTime;
                      break;
                    case 'ISO8601':
                      var auxiliarr = String(aux[i][key])
                      const dates = new Date(auxiliarr)
                      const hourss = dates.getHours();
                      const minutess = dates.getMinutes();
                      const formattedTimess = `${hourss.toString().padStart(2, '0')}:${minutess.toString().padStart(2, '0')}`;
                      aux[i][key]=formattedTimess;
                      break;
                    case 'hh:mm:ss':
                      var auxiliarrr = String(aux[i][key])
                      aux[i][key]=auxiliarrr.substring(0, 5);
                      break;
                    default:
                      break;
                  }
                }
                // console.log('Una más',aux)
                return aux
              }
            )
              break; 
            case 'order_servicetime1':
            case 'order_servicetime2':
            case 'order_weight':
              // console.log('Opción: ',key,dataTable,select);
              setdataTable((prev)=>{
                const aux = [...prev];
                const auxi = (key==='order_servicetime1')
                  ?order_servicetime1
                  :(key==='order_servicetime2')
                    ?order_servicetime2
                    :(key==='order_weight')
                      ?order_weight
                      :order_weight
                for (var i = 0; i < aux.length; i++) {
                  if(key==='order_servicetime1')aux[i].order_servicetime1=(parseFloat(aux[i].order_servicetime1)*parseFloat(auxi)).toFixed(3)
                  else if(key==='order_servicetime2')aux[i].order_servicetime2=(parseFloat(aux[i].order_servicetime2)*parseFloat(auxi)).toFixed(3)
                  else if(key==='order_weight')aux[i].order_weight=(parseFloat(aux[i].order_weight)*parseFloat(auxi)).toFixed(3)
                }
                return aux
              })
              break;
            case 'order_bolactivo':
              // console.log('Opción: ',key,dataTable,select);
              setdataTable((prev)=>{
                const aux = [...prev];
                for (var i = 0; i < aux.length; i++) {
                  if(aux[i].order_bolactivo===order_bolactivo[0]){
                    aux[i].order_bolactivo='0'
                  }else if(aux[i].order_bolactivo===order_bolactivo[1]){
                    aux[i].order_bolactivo='1'
                  }
                }
                return aux
              }
            )
              break;
            default:
              console.log('Opción no reconocida',dataTable,select);
          }
        }
      });

    }
  }

  function onchange_orderMode(input,num){
    // console.log(`input`, order_mode);
    setorder_mode((prev)=>{
      var check=prev
      check[num]=input.target.value
      return check
    })
  };

  function idHubChange(input,num){
    // console.log(`idHubChange`, input.target.value,num);
    setorder_idhubVec((prev)=>{
      // console.log(prev)
      var check=prev
      check[num]=input.target.value
      return check
    })
  };

  function addRem_orderHub(isAdd) {
    if (isAdd) {
      setorder_idhub((prev) => {
        const newOrder_idhub = [
          ...prev,
          <Col><Input
            key={order_idhubN}
            onChange={(input)=>idHubChange(input,order_idhubN)}
              addonBefore="Hub name"
              addonAfter={order_idhubN}
              placeholder={`Hub ${order_idhubN}`}
          />
          <p></p></Col>
        ];
        setorder_idhubN((prev) => prev + 1);
        setorder_idhubVec((prev) => {
          var check=prev
          check.push('')
          return check
        });
        return newOrder_idhub;
      });
    } else {
      if(order_idhubN>0){
        setorder_idhub((prev) => {
          const newOrder_idhub = [...prev];
          newOrder_idhub.pop();
          setorder_idhubN((prev) => prev - 1);
          setorder_idhubVec((prev) => {
            var check=prev
            check.pop()
            return check
          });
          return newOrder_idhub;
        });
      }
    }
  }

  function onchange_orderBolactivo(input,num){
    // console.log(`input`, order_bolactivo);
    setorder_bolactivo((prev)=>{
      var check=prev
      check[num]=input.target.value
      return check
    })
  };

  function onchange_date(input,num){
    if(num===0){
      setorder_earlytime1(input)
    }else if(num===1){
      setorder_latetime1(input)
    }else if(num===2){
      setorder_earlytime2(input)
    }else if(num===3){
      setorder_latetime2(input)
    }
    // console.log(`input`, order_earlytime1,order_latetime1);
  };

  function onchange_mult(input,num){
    if(num===0){
      setorder_servicetime1(parseFloat(input))
    }else if(num===1){
      setorder_weight(parseFloat(input))
    }else if(num===2){
      setorder_servicetime2(parseFloat(input))
    }
    // console.log(`input`, order_servicetime1,order_weight,order_servicetime2);
  };

  const props = {
    name: "file",
    multiple: false,
    action: 'http://www.mocky.io/v2/5cc8019d300000980a055e76',
    // action: `${basePath}/${apiVersion}/orders-database`,
    // headers: {
    //   Authorization: "Bearer " + getAccessTokenApi(),
    //   refreshToken: "Bearer " + getRefreshTokenApi(),
    //   functionname:'uploadOrders',
    //   keyrockAuth: getKeyrockTokenApi(),
    //   ippublica:getPublicIP()
    // },
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
       
      }
      if (status === "done") {
       
      } else if (status === "error") {
       
      }
    },
    onDrop(e) {
    },
   
    beforeUpload(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const worksheet = workbook.Sheets[workbook.SheetNames[0]];
          const parsedData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          setJsonData((vect)=>parsedData);
          // console.log(parsedData)
          if (workbook.SheetNames.length > 1) {
            message.error('The Excel should be 1 Sheet only.');
            return false;
          }
          message.success('Click Next!');
          return true;
        };
        reader.readAsArrayBuffer(file);
      });
    },
  };


  
  if(page===0){
    return (
      <div>
        <div className="sendV2" >
              <div style={{
                margin:'10px',
                height:'100%',width:'100%',
                }}>
                <div style={{
                  display:'flex',
                  fontFamily:'report-bold',
                  fontSize:'25px',
                  flexDirection:'row',
                  justifyContent:'center',}}>
                  <h1>Store your historical data</h1>
                  </div>
                <div style={{
                  display:'flex',
                  fontFamily:'report',
                  fontSize:'18px',
                  flexDirection:'row',
                  justifyContent:'center',}}>
                  <h1>Follow this steps:</h1>
                  </div>
                <div style={{
                  display:'flex',
                  flexDirection:'row',
                  alignItems:'center',
                  justifyContent:'center',}}>
                    <div className="send-num1">
                      <h1 style={{
                        fontFamily:'report',
                        fontSize:'15px',}}>Upload an Excel file (.xlsx)</h1>
                    </div>
                    <div className="send-sepa">
                    </div>
                    <div className="send-num1">
                      <h1 style={{
                        fontFamily:'report',
                        fontSize:'15px',}}>Match your columns with the suggested topics</h1>
                    </div>
                    <div className="send-sepa">
                    </div>
                    <div className="send-num1">
                      <h1 style={{
                        fontFamily:'report',
                        fontSize:'15px',}}>Show the data uploaded and edit it if you want</h1>
                    </div>
                    <div className="send-sepa">
                    </div>
                    <div className="send-num1">
                      <h1 style={{
                        fontFamily:'report',
                        fontSize:'15px',}}>Save all the data</h1>
                    </div>
                   
                </div>
              </div>
          </div> 
        <p></p>
        <Dragger {...props}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p style={{
            fontFamily:'report',
            fontSize:'18px',}} className="ant-upload-text">
            Click or drag file to this area to upload the data
          </p>
          <p style={{
            fontFamily:'report',
            fontSize:'18px',}} className="ant-upload-text">
            and click NEXT
          </p>
          <p style={{
            fontFamily:'report',
            fontSize:'18px',}} className="ant-upload-hint">
            Support for a single or bulk upload. Strictly prohibit from uploading
            company data or other band files
          </p>
        </Dragger>
        <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
          <Button className="boton"
            disabled={/* disable */false}
            style={{borderColor: "rgb(35,148,212)", 
            borderWidth:'2px',
            fontFamily:'report',
            color:'rgb(0,104,178)',
            marginTop:'20px',
            fontSize:'18px',
            backgroundColor: "white" }}
            type="primary"
            onClick={ () => {
              window.location.href = "/admin/historyData";
            }}>
            View your saved data
          </Button>
          <div className="RowMiddle">
          </div>
          <Button className="boton"
            disabled={/* disable */false}
            style={{borderColor: "rgb(35,148,212)", 
            borderWidth:'2px',
            fontFamily:'report',
            color:'rgb(0,104,178)',
            marginTop:'20px',
            fontSize:'18px',
            backgroundColor: "white" }}
            type="primary"
            onClick={ () => {
             
              if(jsonData.length>0){
                setPage(1)
              }else{
                notification["error"]({
                  message: `Upload an Excel`,
                  description:'Upload an excel to cotinue the simulation'
                });
              }
             
              }}>
            Next
            <ArrowRightOutlined />
          </Button>
          </div>
          <p></p>
      </div>
    );
  } else if (page===1){

    return (
      <div>
        <h2 style={{ fontFamily:'report-bold',
            fontSize:'25px',}}>Match de columns</h2>
        {columns}
        <div style={{display:'flex',flexDirection:'Row',justifyContent:'space-between'}}>
        {/* <Button className="boton"
            type="primary"
            style={{borderColor: "rgb(35,148,212)", 
                borderWidth:'2px',
                fontFamily:'report',
                color:'rgb(0,104,178)',
                fontSize:'18px',
                backgroundColor: "white" }}
            onClick={() => {setPage(0);}}>
              <ArrowLeftOutlined />
            Back
            
          </Button> */}
          <p></p>
          <Button className="boton"
            type="primary"
            style={{borderColor: "rgb(35,148,212)", 
                borderWidth:'2px',
                fontFamily:'report',
                color:'rgb(0,104,178)',
                fontSize:'18px',
                backgroundColor: "white" }}
            onClick={() => {
              var isEmpty=false
              var vectorAux
              var dataAux=[]
              setselect((prev)=>{
                // console.log(prev)
                vectorAux=prev
                for (var i = 0; i < vectorAux.length; i++) {
                  if (vectorAux[i] === undefined) {
                    isEmpty = true;
                    break;
                  }
                }

                if(!isEmpty){
                  var conjunto = new Set();//columnas repetidas
                  for (var i = 0; i < vectorAux.length; i++) {
                    var componente = vectorAux[i];
                    if (conjunto.has(componente)) {
                      if(componente!=='None'){
                        isEmpty = true;
                        break;
                      }
                    }
                    conjunto.add(componente);
                  }
                }
                return vectorAux
              })
              if(!isEmpty){
                for (var i = 1; i < jsonData.length; i++) {
                  var fila = jsonData[i];
                  var objeto = {};
                  for (var j = 0; j < vectorAux.length; j++) {
                    var clave = vectorAux[j];
                    var valor = fila[j];
                    objeto[clave] = valor;
                  }
                  dataAux.push(objeto);
                }
                setdataTable(dataAux)

              }
              // console.log(dataAux)
              !isEmpty?setPage(2):message.error('You must match all the columns without repetition')
              }}>
            Next
              <ArrowRightOutlined />
            
          </Button>
          </div>
      </div>
    );
  } else if (page===2){
    // jsonData
    // console.log('seeeh',select,jsonData,dataManag)
    return (
      <div>
        <h2 style={{ fontFamily:'report-bold',
            fontSize:'25px',}}>Help the algorithm to match the data</h2>
        {
          (dataManag.length>0)
            ?<Divider/>
            : <h2 style={{ fontFamily:'report-bold',
            fontSize:'18px',}}>Your data is ready, click Next</h2>
        }
        {(dataManag.includes('order_mode'))?
          <div>
            <h2 style={{ fontFamily:'report-bold',
            fontSize:'18px',}}>{jsonData[0][select.indexOf('order_mode')]}{' => Order mode ("delivery","pickup"...)'}</h2>
            <Row style={{justifyContent:'space-between'}}>
              <Row>
                <Checkbox onChange={(e)=>onChange('order_mode',e)}>&nbsp;&nbsp;&nbsp;&nbsp;</Checkbox>
                <Col style={{width:'320px',textAlign: 'justify'}}>
                  <p>Match your order type with ours and click the checkbox if you haven't already used our order types.</p>
                </Col>
              </Row>
              <Col>
                <Input addonBefore="pickup" placeholder="pickup" onChange={(input)=>onchange_orderMode(input,0)}/>
              </Col>
              <Col>
                <Input addonBefore="delivery" placeholder="delivery" onChange={(input)=>onchange_orderMode(input,1)}/>
              </Col>
              <Col>
                <Input addonBefore="shipment" placeholder="shipment" onChange={(input)=>onchange_orderMode(input,2)}/>
              </Col>
            </Row>
          <Divider/>
          </div>
        :<p></p>}
        {(dataManag.includes('order_idhub'))?
          <div>
            <h2 style={{ fontFamily:'report-bold',
            fontSize:'18px',}}>{jsonData[0][select.indexOf('order_idhub')]}{' => Hub departure (0, 1, 2...)'}</h2>
            <Row style={{justifyContent:'space-between'}}>
              <Row>
                <Checkbox onChange={(e)=>onChange('order_idhub',e)}>&nbsp;&nbsp;&nbsp;&nbsp;</Checkbox>
                <Col style={{width:'320px',textAlign: 'justify'}}>
                  <p>Match your order type with ours, or click the checkbox if you have already used our order types.</p>
                </Col>
              </Row>
              <Row>
                <Button className="boton"
                  type="primary"
                  style={{borderColor: "rgb(35,148,212)", 
                  borderWidth:'2px',
                  fontFamily:'report',
                  color:'rgb(0,104,178)',
                  fontSize:'18px',
                  marginRight:'10px',
                  backgroundColor: "white" }}
                  onClick={() => addRem_orderHub(true)}>
                    +
                </Button>
                <Button className="boton"
                  type="primary"
                  style={{borderColor: "red", 
                  borderWidth:'2px',
                  fontFamily:'report',
                  color:'red',
                  fontSize:'18px',
                  backgroundColor: "white" }}
                  onClick={() => addRem_orderHub(false)}>
                    -
                </Button>
              </Row>
              {order_idhub}
            </Row>
          <Divider/>
          </div>
        :<p></p>}
        {(dataManag.includes('order_earlytime1'))?
          <div>
            <h2 style={{ fontFamily:'report-bold',
            fontSize:'18px',}}>{jsonData[0][select.indexOf('order_earlytime1')]}{' => Minimum delivery time (00:00)'}</h2>
            <Row style={{justifyContent:'space-between'}}>
              <Row>
                <Checkbox onChange={(e)=>onChange('order_earlytime1',e)}>&nbsp;&nbsp;&nbsp;&nbsp;</Checkbox>
                <Col style={{width:'320px',textAlign: 'justify'}}>
                  <p>Match your hour format with ours, or click the checkbox if you have already used our format.</p>
                </Col>
              </Row>
              <Col>
                <Select
                  placeholder="Choose one factor to multiply:"
                  onChange={(input) => {
                    onchange_date(input,0)
                  }}
                  style={{
                    width: '350px',
                  }}
                  defaultValue={'hh:mm'}
                >
                  <Option value='Unix'>Unix (seg) Example: 1688049815</Option>
                  <Option value='UnixMili'>Unix (miliseg) Example: 1688049815000</Option>
                  <Option value='UnixMicro'>Unix (microseg) Example: 1688049815000000</Option>
                  <Option value='ISO8601'>ISO 8601 Example: 2023-06-29T14:43:29</Option>
                  <Option value='hh:mm:ss'>hh:mm:ss Example: 19:45:32</Option>
                </Select>
              </Col>
            </Row>
          <Divider/>
          </div>
        :<p></p>}
        {(dataManag.includes('order_latetime1'))?
          <div>
            <h2 style={{ fontFamily:'report-bold',
            fontSize:'18px',}}>{jsonData[0][select.indexOf('order_latetime1')]}{' => Maximum delivery time (00:00)'}</h2>
            <Row style={{justifyContent:'space-between'}}>
              <Row>
                <Checkbox onChange={(e)=>onChange('order_latetime1',e)}>&nbsp;&nbsp;&nbsp;&nbsp;</Checkbox>
                <Col style={{width:'320px',textAlign: 'justify'}}>
                  <p>Match your hour format with ours, or click the checkbox if you have already used our format.</p>
                </Col>
              </Row>
              <Col>
                <Select
                  placeholder="Choose one factor to multiply:"
                  onChange={(input) => {
                    onchange_date(input,1)
                  }}
                  style={{
                    width: '350px',
                  }}
                  defaultValue={'hh:mm'}
                >
                  <Option value='Unix'>Unix (seg) Example: 1688049815</Option>
                  <Option value='UnixMili'>Unix (miliseg) Example: 1688049815000</Option>
                  <Option value='UnixMicro'>Unix (microseg) Example: 1688049815000000</Option>
                  <Option value='ISO8601'>ISO 8601 Example: 2023-06-29T14:43:29</Option>
                  <Option value='hh:mm:ss'>hh:mm:ss Example: 19:45:32</Option>
                </Select>
              </Col>
            </Row>
          <Divider/>
          </div>
        :<p></p>}
        {(dataManag.includes('order_servicetime1'))?
          <div>
            <h2 style={{ fontFamily:'report-bold',
            fontSize:'18px',}}>{jsonData[0][select.indexOf('order_servicetime1')]}{' => Service time (0, 1, 2...)'}</h2>
            <Row style={{justifyContent:'space-between'}}>
              <Row>
                <Checkbox onChange={(e)=>onChange('order_servicetime1',e)}>&nbsp;&nbsp;&nbsp;&nbsp;</Checkbox>
                <Col style={{width:'320px',textAlign: 'justify'}}>
                  <p>Select a value to multiply and change the units of your lead time data, or click the checkbox if you agree with your data</p>
                </Col>
              </Row>
              <Col>
              <Select
                  placeholder="Choose one factor to multiply:"
                  onChange={(input) => {
                    onchange_mult(input,0)
                  }}
                  style={{
                    width: '300px',
                  }}
                  defaultValue={'1'}
                >
                  <Option value='60'>60 {'(hours->min or min->seg)'}</Option>
                  <Option value='3600'>3600 {'(hours->seg)'}</Option>
                  <Option value='0.01666666666666'>1/60 {'(min->hours or seg->min)'}</Option>
                  <Option value='0.00027777777777'>1/3600 {'(seg->hours)'}</Option>
                </Select>
              </Col>
            </Row>
          <Divider/>
          </div>
        :<p></p>}
        {(dataManag.includes('order_weight'))?
          <div>
            <h2 style={{ fontFamily:'report-bold',
            fontSize:'18px',}}>{jsonData[0][select.indexOf('order_weight')]}{' => Weight (1, 1.5, 2...)'}</h2>
            <Row style={{justifyContent:'space-between'}}>
              <Row>
                <Checkbox onChange={(e)=>onChange('order_weight',e)}>&nbsp;&nbsp;&nbsp;&nbsp;</Checkbox>
                <Col style={{width:'320px',textAlign: 'justify'}}>
                  <p>Select a value to multiply and change the units of your weight data, or click the checkbox if you agree with your data</p>
                </Col>
              </Row>
              <Col>
              <Select
                  placeholder="Choose one factor to multiply:"
                  onChange={(input) => {
                    onchange_mult(input,1)
                  }}
                  style={{
                    width: '300px',
                  }}
                  defaultValue={'1'}
                >
                  <Option value='10'>10</Option>
                  <Option value='100'>100</Option>
                  <Option value='1000'>1000</Option>
                  <Option value='0.1'>1/10</Option>
                  <Option value='0.01'>1/100</Option>
                  <Option value='0.001'>1/1000</Option>
                </Select>
              </Col>
            </Row>
          <Divider/>
          </div>
        :<p></p>}
        {(dataManag.includes('order_earlytime2'))?
          <div>
            <h2 style={{ fontFamily:'report-bold',
            fontSize:'18px',}}>{jsonData[0][select.indexOf('order_earlytime2')]}{' => Minimum delivery time (shipment)'}</h2>
            <Row style={{justifyContent:'space-between'}}>
              <Row>
                <Checkbox onChange={(e)=>onChange('order_earlytime2',e)}>&nbsp;&nbsp;&nbsp;&nbsp;</Checkbox>
                <Col style={{width:'320px',textAlign: 'justify'}}>
                  <p>Match your hour format with ours, or click the checkbox if you have already used our format.</p>
                </Col>
              </Row>
              <Col>
                <Select
                  placeholder="Choose one factor to multiply:"
                  onChange={(input) => {
                    onchange_date(input,2)
                  }}
                  style={{
                    width: '350px',
                  }}
                  defaultValue={'hh:mm'}
                >
                  <Option value='Unix'>Unix (seg) Example: 1688049815</Option>
                  <Option value='UnixMili'>Unix (miliseg) Example: 1688049815000</Option>
                  <Option value='UnixMicro'>Unix (microseg) Example: 1688049815000000</Option>
                  <Option value='ISO8601'>ISO 8601 Example: 2023-06-29T14:43:29</Option>
                  <Option value='hh:mm:ss'>hh:mm:ss Example: 19:45:32</Option>
                </Select>
              </Col>
            </Row>
          <Divider/>
          </div>
        :<p></p>}
        {(dataManag.includes('order_latetime2'))?
          <div>
            <h2 style={{ fontFamily:'report-bold',
            fontSize:'18px',}}>{jsonData[0][select.indexOf('order_latetime2')]}{' => Maximum delivery time (shipment)'}</h2>
            <Row style={{justifyContent:'space-between'}}>
              <Row>
                <Checkbox onChange={(e)=>onChange('order_latetime2',e)}>&nbsp;&nbsp;&nbsp;&nbsp;</Checkbox>
                <Col style={{width:'320px',textAlign: 'justify'}}>
                  <p>Match your hour format with ours, or click the checkbox if you have already used our format.</p>
                </Col>
              </Row>
              <Col>
                <Select
                  placeholder="Choose one factor to multiply:"
                  onChange={(input) => {
                    onchange_date(input,3)
                  }}
                  style={{
                    width: '350px',
                  }}
                  defaultValue={'hh:mm'}
                >
                  <Option value='Unix'>Unix (seg) Example: 1688049815</Option>
                  <Option value='UnixMili'>Unix (miliseg) Example: 1688049815000</Option>
                  <Option value='UnixMicro'>Unix (microseg) Example: 1688049815000000</Option>
                  <Option value='ISO8601'>ISO 8601 Example: 2023-06-29T14:43:29</Option>
                  <Option value='hh:mm:ss'>hh:mm:ss Example: 19:45:32</Option>
                </Select>
              </Col>
            </Row>
          <Divider/>
          </div>
        :<p></p>}
        {(dataManag.includes('order_servicetime2'))?
          <div>
            <h2 style={{ fontFamily:'report-bold',
            fontSize:'18px',}}>{jsonData[0][select.indexOf('order_servicetime2')]}{' => Service time (shipment)'}</h2>
            <Row style={{justifyContent:'space-between'}}>
              <Row>
                <Checkbox onChange={(e)=>onChange('order_servicetime2',e)}>&nbsp;&nbsp;&nbsp;&nbsp;</Checkbox>
                <Col style={{width:'320px',textAlign: 'justify'}}>
                  <p>Select a value to multiply and change the units of your lead time data, or click the checkbox if you agree with your data</p>
                </Col>
              </Row>
              <Col>
              <Select
                  placeholder="Choose one factor to multiply:"
                  onChange={(input) => {
                    onchange_mult(input,2)
                  }}
                  style={{
                    width: '300px',
                  }}
                  defaultValue={'1'}
                >
                 <Option value='60'>60 {'(hours->min or min->seg)'}</Option>
                  <Option value='3600'>3600 {'(hours->seg)'}</Option>
                  <Option value='0.01666666666666'>1/60 {'(min->hours or seg->min)'}</Option>
                  <Option value='0.00027777777777'>1/3600 {'(seg->hours)'}</Option>
                </Select>
              </Col>
            </Row>
            <Divider/>
          </div>
        :<p></p>}
        {(dataManag.includes('order_bolactivo'))?
          <div>
            <h2 style={{ fontFamily:'report-bold',
            fontSize:'18px',}}>{jsonData[0][select.indexOf('order_bolactivo')]}{' => Order to place (0 - 1)'}</h2>
            <Row style={{justifyContent:'space-between'}}>
              <Row>
                <Checkbox onChange={(e)=>onChange('order_bolactivo',e)}>&nbsp;&nbsp;&nbsp;&nbsp;</Checkbox>
                <p></p>
                <Col style={{width:'400px',textAlign: 'justify'}}>
                  <p>Add the way in which you have indicated whether or not it has been delivered, or click the checkbox if you have already used 1 and 0.</p>
                </Col>
              </Row>
              <Col>
                <Input addonBefore="1" placeholder="Yes" onChange={(input)=>onchange_orderBolactivo(input,1)}/>
              </Col>
              <Col>
                <Input addonBefore="0" placeholder="No" onChange={(input)=>onchange_orderBolactivo(input,0)}/>
              </Col>
            </Row>
          <p></p>
          </div>
        :<p></p>}
        <p></p>
        <div style={{display:'flex',flexDirection:'Row',justifyContent:'space-between'}}>
        {/* <Button className="boton"
            type="primary"
            style={{borderColor: "rgb(35,148,212)", 
                borderWidth:'2px',
                fontFamily:'report',
                color:'rgb(0,104,178)',
                fontSize:'18px',
                backgroundColor: "white" }}
            onClick={() => {setPage(1);}}>
              <ArrowLeftOutlined />
            Back
            
          </Button> */}
          <p></p>
          <Button className="boton"
            type="primary"
            style={{borderColor: "rgb(35,148,212)", 
                borderWidth:'2px',
                fontFamily:'report',
                color:'rgb(0,104,178)',
                fontSize:'18px',
                backgroundColor: "white" }}
            onClick={async () => {
              setCircular(true)
              await processData()
              setCircular(false)
              setPage(3);
            }}>
            Next
              <ArrowRightOutlined />
            
          </Button>
        </div>
       { (circular)
        ?<div style={{display:'flex',justifyContent:'center'}}>
          <div></div>
          <div className="cargandos"></div>
          <div></div>
        </div>
        :<div className="vacio"></div>}
      </div>
    );
  } else if (page===3){
    // jsonData
    return (
      <div>
        <h2 style={{ fontFamily:'report-bold',
            fontSize:'25px',}}>Check your data</h2>
        <TableFullEditable
          columns={select}
          datos={dataTable}
        ></TableFullEditable>
        <p></p>
        <div style={{display:'flex',flexDirection:'Row',justifyContent:'space-between'}}>
        <Button className="boton"
            type="primary"
            style={{borderColor: "rgb(35,148,212)", 
                borderWidth:'2px',
                fontFamily:'report',
                color:'rgb(0,104,178)',
                fontSize:'18px',
                backgroundColor: "white" }}
            onClick={() => {
              window.location.href = "/admin/history";}}>
            Unsave dataset
            
          </Button>
          <p></p>
          <Button className="boton"
            type="primary"
            style={{borderColor: "rgb(35,148,212)", 
                borderWidth:'2px',
                fontFamily:'report',
                color:'rgb(0,104,178)',
                fontSize:'18px',
                backgroundColor: "white" }}
            onClick={async () => {
              setCircular(true)
              await post(dataTable,'save-history-data','save-history-data','')
              // await saveHistoryData(dataTable)
              setCircular(false)
              window.location.href = "/admin/historyData"
              }}>
              <SaveOutlined />
            Save Data
            
          </Button>
          </div>
          { (circular)
        ?<div style={{display:'flex',justifyContent:'center'}}>
          <div></div>
          <div className="cargandos"></div>
          <div></div>
        </div>
        :<div className="vacio"></div>}
      </div>
    );
  } else {

    return (
      <div>
        <h2 style={{ fontFamily:'report-bold',
            fontSize:'25px',}}>In development</h2>
        <Button className="boton"
            type="primary"
            style={{borderColor: "rgb(35,148,212)", 
            borderWidth:'2px',
            fontFamily:'report',
            color:'rgb(0,104,178)',
            fontSize:'18px',
            backgroundColor: "white" }}
            onClick={() => {setPage(0)}}>
              <ArrowLeftOutlined />
            Back
            
          </Button>
      </div>
    );
  }
}




